import { io, Socket } from 'socket.io-client'
import { store } from '../store/store'
import { FilterNames } from '../common/types/enums'
import {
  CargoItemInterface,
  CargoListResponse,
  ChatMessage,
  Client,
  SlotItemInterface,
  SlotListResponse,
  Topic,
  TransportItemInterface,
  TransportListResponse,
} from '../common/types/interfaces'
import { setConnected, setConnectedList } from '../store/slices/wsSlice'
import { removeSlotById, replaceSlotById, setSlotList } from '../store/slices/slotListSlice'
import { removeCargoById, replaceCargoById, setCargoList } from '../store/slices/cargoListSlice'
import {
  removeTransportById,
  replaceTransportById,
  setTransportList,
} from '../store/slices/transportListSlice'
import {
  addMessageToTopicById,
  addTopic,
  markAsRead,
  setTopicList,
} from '../store/slices/chatSlice'
import { getApi } from './../api/api'
import {
  CARGO_MY_ROUTE,
  CARGO_SELECTED_ROUTE,
  cargoFilterPattern,
  MAIN_ROUTE,
  SLOT_MY_ROUTE,
  SLOT_SELECTED_ROUTE,
  slotFilterPattern,
  TRANSPORT_MY_ROUTE,
  TRANSPORT_SELECTED_ROUTE,
  transportFilterPattern,
} from '../common/utils/constants'
import { endOfMonth, startOfYear } from 'date-fns'

// Константа для отключения получения списков
const SYNC_LIST_DATA = false // true - получать, false - не получать

const COUNTRY = process.env.REACT_APP_COUNTRY || 'ru';
const DOMAIN = COUNTRY === 'ru' ? 'ru' : COUNTRY;
const baseUrl = `https://logid.${DOMAIN}/web`;

let ws: Ws | null = null

class Ws {
  socket: Socket | null = null
  isConnected = false
  api

  constructor(baseUrl: string) {
    this.socket = io(baseUrl)
    this.api = getApi()

    this.socket.on('connect', () => {
      store.dispatch(setConnected(true))
      this.isConnected = true
      this.authEmit()
    })

    this.socket.on('disconnect', () => {
      store.dispatch(setConnected(false))
      this.isConnected = false
      setTimeout(() => {
        if (this.socket) this.socket.connect()
      }, 1000)
    })

    this.socket.on('connected-list', (data: Client[] | []) => {
      store.dispatch(setConnectedList(data))
    })

    this.socket.on('slot-state', async () => {
      // Получаем списки только если SYNC_LIST_DATA = true
      if (!SYNC_LIST_DATA) return
      
      try {
        const location = window.location.pathname
        const filters = localStorage.getItem(
          location === SLOT_SELECTED_ROUTE
            ? FilterNames.SLOT_SELECTED
            : location === SLOT_MY_ROUTE
            ? FilterNames.SLOT_MY
            : FilterNames.SLOT,
        )
        let result: SlotListResponse
        if (store.getState().auth.token) {
          result = await this.api.getSlotList(
            filters && window.location.pathname !== MAIN_ROUTE
              ? JSON.parse(filters)
              : {
                  ...slotFilterPattern,
                  gte: startOfYear(new Date()),
                  lte: endOfMonth(new Date()),
                },
          )
        } else {
          result = await this.api.getAdSlotList(
            filters && window.location.pathname !== MAIN_ROUTE
              ? JSON.parse(filters)
              : {
                  ...slotFilterPattern,
                  gte: startOfYear(new Date()),
                  lte: endOfMonth(new Date()),
                },
          )
        }
        store.dispatch(setSlotList(result))
      } catch (error) {}
    })

    this.socket.on('cargo-state', async () => {
      // Получаем списки только если SYNC_LIST_DATA = true
      if (!SYNC_LIST_DATA) return
      
      try {
        const location = window.location.pathname
        const filters = localStorage.getItem(
          location === CARGO_SELECTED_ROUTE
            ? FilterNames.SLOT_SELECTED
            : location === CARGO_MY_ROUTE
            ? FilterNames.SLOT_MY
            : FilterNames.CARGO,
        )
        let result: CargoListResponse

        if (store.getState().auth.token) {
          result = await this.api.getCargoList(
            filters && window.location.pathname !== MAIN_ROUTE
              ? JSON.parse(filters)
              : {
                  ...cargoFilterPattern,
                  gte: startOfYear(new Date()),
                  lte: endOfMonth(new Date()),
                },
          )
        } else {
          result = await this.api.getAdCargoList(
            filters && window.location.pathname !== MAIN_ROUTE
              ? JSON.parse(filters)
              : {
                  ...cargoFilterPattern,
                  gte: startOfYear(new Date()),
                  lte: endOfMonth(new Date()),
                },
          )
        }

        store.dispatch(setCargoList(result))
      } catch (error) {}
    })

    this.socket.on('transport-state', async () => {
      // Получаем списки только если SYNC_LIST_DATA = true
      if (!SYNC_LIST_DATA) return
      
      try {
        const location = window.location.pathname
        const filters = localStorage.getItem(
          location === TRANSPORT_SELECTED_ROUTE
            ? FilterNames.TRANSPORT_SELECTED
            : location === TRANSPORT_MY_ROUTE
            ? FilterNames.TRANSPORT_MY
            : FilterNames.TRANSPORT,
        )
        let result: TransportListResponse
        if (store.getState().auth.token) {
          result = await this.api.getTransportList(
            filters && window.location.pathname !== MAIN_ROUTE
              ? JSON.parse(filters)
              : {
                  ...transportFilterPattern,
                  gte: startOfYear(new Date()),
                  lte: endOfMonth(new Date()),
                },
          )
        } else {
          result = await this.api.getAdTransportList(
            filters && window.location.pathname !== MAIN_ROUTE
              ? JSON.parse(filters)
              : {
                  ...transportFilterPattern,
                  gte: startOfYear(new Date()),
                  lte: endOfMonth(new Date()),
                },
          )
        }
        store.dispatch(setTransportList(result))
      } catch (error) {}
    })

    this.socket.on('cargo-item-state', async (id: number) => {

      let item: CargoItemInterface
      try {
        if (
          store.getState().auth.token &&
          store.getState().cargoList.data.data.find((el) => el.id === id)
        ) {
          item = await this.api.getCargo(id)
        } else {
          item = await this.api.getAdCargo(id)
        }
        if (item) {
          store.dispatch(replaceCargoById(item))
        } else {
          store.dispatch(removeCargoById(id))
        }
      } catch (error) {}
    })

    this.socket.on('slot-item-state', async (id: number) => {
      try {
        let item: SlotItemInterface
        try {
          if (
            store.getState().auth.token &&
            store.getState().slotList.data.data.find((el) => el.id === id)
          ) {
            item = await this.api.getSlot(id)
          } else {
            item = await this.api.getAdSlot(id)
          }
          if (item) {
            store.dispatch(replaceSlotById(item))
          } else {
            store.dispatch(removeSlotById(id))
          }
        } catch (error) {}
      } catch (error) {}
    })

    this.socket.on('transport-item-state', async (id: number) => {
      try {
        let item: TransportItemInterface
        try {
          if (
            store.getState().auth.token &&
            store.getState().transportList.data.data.find((el) => el.id === id)
          ) {
            item = await this.api.getTransport(id)
          } else {
            item = await this.api.getAdTransport(id)
          }
          if (item) {
            store.dispatch(replaceTransportById(item))
          } else {
            store.dispatch(removeTransportById(id))
          }
        } catch (error) {}
      } catch (error) {}
    })

    this.socket.on('chatMessage', async (data: ChatMessage) => {
      try {
        if (
          store.getState().chat.currentTopic &&
          store.getState().chat.currentTopic?.id === data.topicId
        ) {
          await this.api.markAsRead({ uuid: [data.uuid] })
          store.dispatch(addMessageToTopicById({ ...data, read: true }))
          return
        }
        store.dispatch(addMessageToTopicById(data))
      } catch (error) {}
    })

    this.socket.on('messageRead', (data: ChatMessage) => {
      store.dispatch(markAsRead(data))
    })

    this.socket.on('updateTopicList', async () => {
      const userId = store.getState().currentUser.user?.id
      if (userId) {
        const result = await this.api.getTopicList(userId)
        store.dispatch(setTopicList(result))
      }
    })

    this.socket.on('topic-creation', (data: Topic) => {
      store.dispatch(addTopic(data))
    })
  }

  emit(message: string, payload: any) {
    if (this.socket) this.socket.emit(message, payload)
  }

  authEmit() {
    if (this.socket) this.socket.emit('auth', store.getState().auth.token)
  }
}

export const getWs = () => {
  if (!ws) ws = new Ws(baseUrl)

  return ws
}